/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sign_Forgot_Password_DescriptionInputs */

const en_common_sign_forgot_password_description = /** @type {(inputs: Common_Sign_Forgot_Password_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter your email and we'll send you a link to reset your password.`)
};

const zh_common_sign_forgot_password_description = /** @type {(inputs: Common_Sign_Forgot_Password_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入你的邮箱，我们将发送密码重置链接。`)
};

/**
* | output |
* | --- |
* | "Enter your email and we'll send you a link to reset your password." |
*
* @param {Common_Sign_Forgot_Password_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_sign_forgot_password_description = /** @type {((inputs?: Common_Sign_Forgot_Password_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sign_Forgot_Password_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_sign_forgot_password_description(inputs)
	return zh_common_sign_forgot_password_description(inputs)
});
export { common_sign_forgot_password_description as "common.sign.forgot_password_description" }